// A rail-local stand-in for `components/Tabs/TabPane`, swapping its
// `Container` (Bootstrap's `.container`) for a plain `div`. Bootstrap's
// `.container` sets a literal `width` (not `max-width`) per viewport
// breakpoint — at >=1200px that's 1368px — regardless of its actual DOM
// parent's width, so inside the rail's 340px-wide pane (`RAIL_WIDTH_PX`,
// `InboxLayout.tsx`) it forces `CustomerPanel`'s two-column `FieldGrid` (see
// `FieldGrid.tsx`) far wider than the pane, clipping the second column
// entirely under the pane's own `overflow: auto` — the FR-63 look-back rail
// was only showing 3 of its 6 rows because of this. No other `TabPane`
// consumer nests a component this width-sensitive inside a pane this
// narrow, so this is scoped to the rail rather than changing the shared
// component's behavior for every other tabbed page. Precedent:
// `scenes/Cms/Settings/components/TermsAndPoliciesTabPane.tsx` does the same
// swap for its own reason.
//
// Body background is white, not the `grey-05-bkg` Bootstrap utility this
// component started with — the rail itself is white (VISUAL-SPEC.md §4,
// `.ib-details`), and the grey utility made the rail read as a distinct
// grey panel against the design's plain white body.
import palette from 'constants/palette'
import React from 'react'
import Tab from 'react-bootstrap-five/Tab'
import { useStyletron } from 'styletron-react'

type Props = {
  state: string
  children: React.ReactNode
}

const RailTabPane = ({ state, children }: Props) => {
  const [css] = useStyletron()

  return (
    <Tab.Pane eventKey={state}>
      <div
        className={css({
          padding: '6px 20px 24px',
          backgroundColor: palette.white,
        })}
      >
        {children}
      </div>
    </Tab.Pane>
  )
}

export default RailTabPane
